const MS_PER_DAY = 86400000;

/** Inicio del día civil local (misma idea que caducidad en modal de licencia). */
const startOfLocalDayMs = (d) => {
    const x = new Date(d);
    if (Number.isNaN(x.getTime())) return Number.NaN;
    return new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
};

/** Licencia vigente hasta el fin del día de caducidad (inclusive). */
export const availableLicense = (dateExpired) => {
    if (!dateExpired) {
        return false;
    }
    const expDay = startOfLocalDayMs(dateExpired);
    const todayDay = startOfLocalDayMs(new Date());
    if (Number.isNaN(expDay) || Number.isNaN(todayDay)) return false;
    return expDay >= todayDay;
};

/** Aviso naranja: aún vigente y quedan ≤30 días civiles hasta la caducidad. */
export const warningLicense = (dateExpired) => {
    if (!dateExpired) {
        return false;
    }
    const expDay = startOfLocalDayMs(dateExpired);
    const todayDay = startOfLocalDayMs(new Date());
    if (Number.isNaN(expDay) || Number.isNaN(todayDay)) return false;
    if (expDay < todayDay) return false;
    const diffDays = Math.floor((expDay - todayDay) / MS_PER_DAY);
    return diffDays <= 30;
};

export const expirationDays = (dateExpired) => {
    const date = new Date(dateExpired);
    const today = new Date();
    const diffTime = Math.abs(date - today);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};

/**
 * `date_min` para APIs nematodo (log entries / Excel): inicio del día civil local a las 00:00:00.000Z.
 */
export const formatApiDateMinDayStart = (date) => {
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) {
        return '1970-01-01T00:00:00.000Z';
    }
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00.000Z`;
};

export const formatDateLicence = (dateExpired) => {
    if (!dateExpired) {
        return '';
    }
    const date = new Date(dateExpired);
    const today = new Date();

    const dia = date.getDate().toString().padStart(2, '0');
    const mes = (date.getMonth() + 1).toString().padStart(2, '0');
    const año = date.getFullYear();

    if (date <= today) {
        return ``;
    } else {
        return `${dia}/${mes}/${año}`;
    }
};